import React, { useState } from "react";
import Image from "next/image";
import classNames from "classnames";
import { Tooltip } from "antd";

//helpers
import collections from "@/api/query/collections";

// interfaces
import { ITypesOfLocations } from "./IMoreFiltersForm";
import { ISingleCollectionResponse } from "@/types/api/SingleCollectionResponse";

//assets
import CollectionPlaceholder from "@/components/icons/CollectionPlaceholder";

import styles from "@/assets/styles/components/Form/more-filters-form.module.scss";
import Button from "@/shared/Button";


const TypesOfLocations = ({ onClick, values }: ITypesOfLocations) => {
  const [isShowAllOtherTypes, setIsShowAllOtherTypes] = useState(false);

  const { data: collectionsList = [] } = collections.useCollectionsList({ params: { is_publish: true } });

  const popularCollections = (collectionsList || []).filter(collection => collection.section === "top");
  const otherCollections = (collectionsList || []).filter(collection => collection.section !== "top");
  

  const renderCollection = (collection: ISingleCollectionResponse, index: number) => {
    const isActive = values.some(value => +value === collection.id);

    const collectionClassName = classNames(
      styles["locl-more-filters__locations-types__card"],
      { [styles["locl-more-filters__locations-types__card__selected"]]: isActive, }
    );

    return (
      <Tooltip
        placement="top"
        trigger="hover"
        align={{ offset: [0, -7] }}
        overlayClassName={styles["locl-more-filters__locations-types__card__tooltip"]}
        title={collection.name}
      >
        <div
          onClick={() => onClick(`${collection.id}`, !isActive, collection.name)}
          key={`${collection.name} ${index}`}
          className={collectionClassName}
          data-testid="locl-more-filters-locations-types-card"
        >
          {
            collection.image
              ? <Image
                width={24}
                height={24}
                src={collection.image}
                className={styles["locl-more-filters__locations-types__card__img"]}
                alt={collection.name}
              />
              : <CollectionPlaceholder/>
          }
          <p className={styles["locl-more-filters__locations-types__card__text"]}>
            {collection.name}
          </p>
        </div>
      </Tooltip>
    );
  };

  const renderOtherTypes = (item: ISingleCollectionResponse, index: number) => {
    if (index > 3 && !isShowAllOtherTypes) {
      return null;
    }

    return renderCollection(item, index);
  }

  return (
    <div className={styles["locl-more-filters__locations-types"]}>
      <div className={styles["locl-more-filters__locations-types__block"]}>
        <div className={styles["locl-more-filters__locations-types__block-title"]}>
          Popular environments
        </div>
        <div className={styles["locl-more-filters__locations-types__items"]}>
          { popularCollections.map(renderCollection) }
        </div>
      </div>
      <div className={styles["locl-more-filters__locations-types__block"]}>
        <div className={styles["locl-more-filters__locations-types__block-title"]}>
          Other environments
        </div>
        <div className={styles["locl-more-filters__locations-types__items"]}>
          { otherCollections.map(renderOtherTypes) }
        </div>
        <Button
          type="secondary"
          success
          fullWidth
          onClick={() => setIsShowAllOtherTypes(!isShowAllOtherTypes)}
        >
          Show { isShowAllOtherTypes ? "less" : "more" }
        </Button>
      </div>
    </div>
  );
};

export default TypesOfLocations;
